import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { TransferTokenService } from 'src/app/services/transfer-token.service';
@Component({
  selector: 'app-bam-loan',
  templateUrl: './bam-loan.component.html',
  styleUrls: ['./bam-loan.component.scss']
})
export class BamLoanComponent {
  accounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  accountOptions: AccountOptionResponse = null;

  user = null;
  company = null;

  bankAccountNumberDebit: string = null;
  loanNumber: string = '';
  currencyPayment: number = 0; // 0 = Quetzales, 1 = Dólares
  isDollar: boolean = false;
  description: string = '';
  amount: number = null;
  paymentType: string = null;

  confirmModalVisible: boolean = false;
  transferPreview: any = null;
  loading: boolean = false;

  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';

  paymentTypeOptions = [
    { code: 'CT', label: 'Cuota Vigente' },
    { code: 'EC', label: 'Aporte a Capital con reducción de Cuota' },
    { code: 'ET', label: 'Aporte a Capital con reducción de Tiempo' },
    { code: 'CD', label: 'Aporte a Capital Directo' }
  ];

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private accountService: AccountService,
    private bamTransferService: BamTransferServiceService,
    private transferTokenService: TransferTokenService
  ) {
    this.user = this.authService.getUser();
    this.company = JSON.parse(this.authService.getCurrentCompany());
  }

  ngOnInit(): void {
    this.getBanksOwn();
    this.getAccountOptions();
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data || [];
        this.filterAccountsDebit = this.accounts.filter(account => account.bank === 4);
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener las cuentas bancarias');
      }
    });
  }

  getAccountOptions() {
    this.accountService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener opciones de cuentas');
      }
    });
  }

  getBankName(idBank: number): string {
    if (!this.accountOptions || !this.accountOptions.erpBanks) return '';
    const bank = this.accountOptions.erpBanks.find(bank => bank.id === idBank);
    return bank ? bank.name : 'Banco desconocido';
  }

  onCurrencyChange() {
    this.currencyPayment = this.isDollar ? 1 : 0;
  }

  getPaymentTypeLabel(code: string): string {
    const option = this.paymentTypeOptions.find(item => item.code === code);
    return option ? `${option.code} - ${option.label}` : code;
  }

  openConfirmModal() {
    if (!this.bankAccountNumberDebit) {
      this.toastService.error('Debes seleccionar una cuenta bancaria');
      return;
    }

    if (!this.loanNumber || !this.loanNumber.trim()) {
      this.toastService.error('Debes ingresar el número de préstamo');
      return;
    }

    const loanRegex = /^[0-9]{16}$/;

    if (!loanRegex.test(this.loanNumber)) {
      this.toastService.error('El número de préstamo debe tener exactamente 16 dígitos numéricos');
      return;
    }

    if (!this.paymentType) {
      this.toastService.error('Debes seleccionar el tipo de pago');
      return;
    }

    if (!this.amount || this.amount <= 0) {
      this.toastService.error('Debes ingresar un monto válido');
      return;
    }

    if (!this.description || !this.description.trim()) {
      this.toastService.error('Debes ingresar una descripción');
      return;
    }

    const debitAccount = this.accounts.find(
      acc => String(acc.accountNumber) === String(this.bankAccountNumberDebit)
    );

    this.transferPreview = {
      bankAccountNumberDebit: this.bankAccountNumberDebit,
      loanNumber: this.loanNumber,
      currencyPayment: this.currencyPayment,
      currencyName: this.currencyPayment === 1 ? 'Dólares (USD)' : 'Quetzales (GTQ)',
      currencySymbol: this.currencyPayment === 1 ? '$' : 'Q',
      description: this.description,
      amount: this.amount,
      paymentType: this.paymentType,
      paymentTypeLabel: this.getPaymentTypeLabel(this.paymentType),
      debitAccount
    };

    this.confirmModalVisible = true;
  }

  confirmTransfer() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    this.confirmModalVisible = false;
    this.sendRequest();
  }

  onCancelTransfer() {
    this.confirmModalVisible = false;
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequest() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    const request = {
      bankAccountNumberDebit: this.bankAccountNumberDebit,
      loanNumber: this.loanNumber,
      currencyPayment: this.currencyPayment,
      description: this.description,
      amount: this.amount,
      company: this.company.companyId,
      paymentType: this.paymentType,
      token: this.code2fa
    };

    this.loading = true;

    this.bamTransferService.sendLoanPayment(request).subscribe({
      next: (_response: any) => {
        if (_response.data.code != "OPERATION_SUCCESSFUL") {
          this.toastService.error(_response.data.message, _response.data.code);
          return;
        }
        this.toastService.success('Pago realizado correctamente');
        this.resetForm();
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al realizar el pago de préstamo', err);
        if (err.data.description) {
          this.toastService.error(err.data.description);
        } else {
          this.toastService.error('Error al realizar el pago');
        }
        this.loading = false;
      }
    });
  }

  resetForm() {
    this.bankAccountNumberDebit = null;
    this.loanNumber = '';
    this.currencyPayment = 0;
    this.isDollar = false;
    this.description = '';
    this.amount = null;
    this.paymentType = null;
    this.transferPreview = null;
    this.confirmModalVisible = false;
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequestCode() {
    this.loadingSendCode = true;
    
    this.transferTokenService.createTokenTransfer().subscribe({
      next: (_response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al solicitar token');
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }
}
